





































































































































































































































import { Component, Vue, Emit, Ref } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import Interceptor from '@finx/web-repository/src/apis/Interceptor'
import Incoming from '@finx/web-repository/src/apis/Incoming/Incoming'
import { getModule } from 'vuex-module-decorators'
import SegurancaApi from '@/Apis/Seguranca/Services/SegurancaApi'
import { SecretariaMedicoValidation, CadastroMedicoValidation } from '@/components/CadastroMedico/store/Validation/Validation'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SnackbarStore from '@/components/Snackbar/Store/SnackbarStore'
import { ISnackbarValidation, TipoConviteEnum, Snackbar, IRequestMessage, RequestMessage, StatusEmailEnum } from '@/types/_'
import { getSnackbarMessage, onlyNumber, validateCPF, validateEmail, timeoutDefault, timeout } from '@/utils/common'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import ModalCadastroMedicoSecretaria from '@/components/CadastroMedico/Modals/ModalCadastroMedicoSecretaria.vue'

@Component({
  components: {
    ModalCadastroMedicoSecretaria,
  },
})
export default class ComponentCadastroSecretaria extends Vue {
  $refs!: { verify: any, formRules: any, formAssociarSecretaria: any }
  nomeSecretaria: string = ''
  dial: boolean = false
  localAtendimentoEnable: boolean = false
  cpfLoader: boolean = false
  emailValid: boolean = false
  emailLoading: boolean = false
  loadVoltar: boolean = false
  loadRedirect: boolean = false
  loadSalvar: boolean = false
  loadAssociarConta: boolean = false
  verifyRules: any = {
    valid: false,
    cpf: [
      v => !!v || 'O campo CPF é obrigatório.',
      v => validateCPF(v) || 'CPF inválido',
    ],
  }

  get getLocalAtendimentoEnable() {
    return this.localAtendimentoEnable
  }

  set getLocalAtendimentoEnable(value: boolean) {
    this.localAtendimentoEnable = value
  }

  get loadingAssociarConta() {
    return this.loadAssociarConta
  }

  set loadingAssociarConta(value: boolean) {
    this.loadAssociarConta = value
  }

  get loadingSalvar() {
    return this.loadSalvar
  }

  set loadingSalvar(value: boolean) {
    this.loadSalvar = value
  }

  get loadingRedirect() {
    return this.loadRedirect
  }

  set loadingRedirect(value: boolean) {
    this.loadRedirect = value
  }

  get getNomeSecretaria() {
    return this.nomeSecretaria
  }

  set getNomeSecretaria(value: string) {
    this.nomeSecretaria = value
  }

  get loadingVoltar() {
    return this.loadVoltar
  }

  set loadingVoltar(value: boolean) {
    this.loadVoltar = value
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get cpfLoading() {
    return this.cpfLoader
  }

  set cpfLoading(val: boolean) {
    this.cpfLoader = val
  }

  get cpfInicial() {
    return this.getCadastroMedicoStore.cpfInicial
  }

  set cpfInicial(value: string) {
    this.getCadastroMedicoStore.setCPFInicial(value)
  }

  get step() {
    return this.getCadastroMedicoStore.currentStep
  }

  set step(value: number) {
    this.getCadastroMedicoStore.setCurrentStep(value)
  }

  get getSnackbarStore() {
    return getModule(SnackbarStore, this.$store)
  }

  get getRequestMessage() {
    const requestMessage: IRequestMessage = new RequestMessage()
    return requestMessage
  }

  get modalCadastroSecretariaDialog() {
    return this.dial
  }

  set modalCadastroSecretariaDialog(value: boolean) {
    this.dial = value
  }

  formRules: any = {
    valid: true,
    nome: [
      v => !!v || 'O campo nome é obrigatório.',
    ],
    emailRules: [
      v => !!v || 'O campo E-mail é obrigatório.',
      v => validateEmail(v) || 'O E-mail deve ser válido.',
    ],
    celularRules: [
      v => !!v || 'O campo celular é obrigatório.',
    ],
    localAtendimento: [
      v => !!v || 'O campo local de atendimento é obrigatório.',
    ],
    sexo: [
      v => !!v || 'O campo sexo é obrigatório.',
    ],
  }

  formAssociarSecretaria: any = {
    valid: true,
    localAtendimento: [
      v => !!v || 'O campo local de atendimento é obrigatório.',
    ],
  }

  async voltarBtn() {
    this.loadingVoltar = true
    await timeoutDefault()
    this.loadingVoltar = false
    this.step = 1
  }

  async sendAlert(url?: String, status?: string, data?, headers?) {
    const user = this.$user
    const detail = `
      URL: ${url}
      Código: ${status}
      Usuário: ${user.profile.email}
      Data: ${JSON.stringify(data)}
      Headers: ${JSON.stringify(headers)}
    `
    const message = {
      title: 'Erro na API',
      text: detail,
      themeColor: 'red',
    }

    Incoming.Alert.sendAlert(message)
  }

  async verifyCPF() {
    this.getNomeSecretaria = ''
    if (this.$refs.verify.validate()) {
      this.cpfLoading = true
      this.getCadastroMedicoStore.cadastroMedico.cpf = this.getCadastroMedicoStore.cpfInicial
      this.getLocalAtendimentoEnable = !!this.getCadastroMedicoStore.cadastroMedico.localAtendimentoNome
      const response = await this.getCadastroMedicoStore.checkSecretariaCpf(this.cpfInicial)
      if (response.success) {
        switch (response.data.checkSecretariaStatus) {
          case 'AssociarConta':
            this.getNomeSecretaria = response.data.nome
            this.getCadastroMedicoStore.cadastroMedico.id = response.data.id
            this.step = 2
            break

          case 'ContinuarCadastro':
            this.step = 3
            break

          default:
            EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'error'))
            break
        }
      } else {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'error'))
      }

      this.cpfLoading = false
    }
  }

  async associarConta() {
    this.loadingAssociarConta = true

    if (this.$refs.formAssociarSecretaria.validate()) {
      const params = {
        localAtendimentoNome: this.getCadastroMedicoStore.cadastroMedico.localAtendimentoNome,
        cpf: this.getCadastroMedicoStore.cadastroMedico.cpf,
        conviteId: this.getCadastroMedicoStore.cadastroMedico.conviteId,
      }

      const response = await this.getCadastroMedicoStore.associarConta(params)

      if (response.success) {
        this.modalCadastroSecretariaDialog = true
      } else {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'error'))
      }
    }

    this.loadingAssociarConta = false
  }

  removeEspecialidade(item: any) {
    this.getCadastroMedicoStore.removeEspecialidades(item)
  }

  addCadastroSecretaria() {
    if (this.isSecretariaValid()) {
      this.getCadastroMedicoStore.addCadastroSecretaria()
    }
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async salvar() {
    this.loadingSalvar = true
    if (this.$refs.formRules.validate()) {
      const defaultErrorMessage = 'Houve um erro no cadastro.'
      const { cadastroMedico } = this.getCadastroMedicoStore
      cadastroMedico.tipoConvite = TipoConviteEnum.SecretariaAgendamento
      const sendCadastroMedicoResponse = await this.getCadastroMedicoStore.sendCadastroMedico(cadastroMedico)
      if (sendCadastroMedicoResponse.success) {
        this.modalCadastroSecretariaDialog = true
      } else {
        // Caso o usuário já esteja cadastrado (e-mail), o back retorna a mensagem "Já existe uma pessoa cadastrada com este email!"
        const emailExisteMessage = 'Já existe uma pessoa cadastrada com este email!'
        if (sendCadastroMedicoResponse.message && sendCadastroMedicoResponse.message === emailExisteMessage) {
          this.getCadastroMedicoStore.cadastroMedicoMessage.email = sendCadastroMedicoResponse.message
        }
        const errorMessage = sendCadastroMedicoResponse.message || defaultErrorMessage
        EventBus.$emit('setSnackbar', getSnackbarMessage(errorMessage, 'error'))
      }
    }
    this.loadingSalvar = false
  }

  async redirect() {
    this.loadingRedirect = true
    if (this.$user) {
      this.$router.push('/')
    } else {
      await Auth.login('./')
    }
    this.loadingRedirect = true
  }

  async closeRedirectionModal() {
    await this.redirect()
    this.modalCadastroSecretariaDialog = false
  }

  isSecretariaValid() {
    const cadastroMedicoValidation = new SecretariaMedicoValidation()
    const cadastroMedicoMessage = cadastroMedicoValidation.isValid(this.getCadastroMedicoStore.cadastroMedico)
    this.getCadastroMedicoStore.setCadastroMedicoMessage(cadastroMedicoMessage)
    this.getSnackbarStore.snackbarValid(cadastroMedicoMessage)
    return cadastroMedicoMessage.success
  }

  removeSecretaria(value: number) {
    this.getCadastroMedicoStore.removeSecretaria(value)
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }
}
